<sharry-header></sharry-header>
<div class="introduction">
  <div class="introduction__content">
    <h1 class="introduction__title">{{ 'recommendation-create-introduction.title-rainbow' | i18next }}</h1>
    <sharry-hero [backGroundImages]="heroImages"></sharry-hero>
    <div class="introduction__meaning">
      <h4 [innerHTML]="'recommendation-create-introduction.meaning-content' | i18next"></h4>
      <h4>
        <button
          class="sharry-simple"
          (click)="goToCreate()">
          {{ 'recommendation-create-introduction.meaning-content-2' | i18next }}
        </button>
      </h4>
      <h4 [innerHTML]="'recommendation-create-introduction.meaning-content-3' | i18next"></h4>
    </div>
    <div class="introduction__advantages">
      <h2>{{ 'recommendation-create-introduction.advantages-title' | i18next }}</h2>
      <ul class="introduction__advantages__list">
        <li class="introduction__advantages__list__element">
          <img
            src="https://media.sharry.land/app/images/img-meraviglie@3x.svg"
            alt="meraviglie" />
          <h3>{{ 'recommendation-create-introduction.advantages-subtitle-1' | i18next }}</h3>
          <p>{{ 'recommendation-create-introduction.advantages-content-1' | i18next }}</p>
        </li>
        <li class="introduction__advantages__list__element">
          <img
            src="https://media.sharry.land/app/images/img-servizi_e_strutture@3x.svg"
            alt="servizi" />
          <h3>{{ 'recommendation-create-introduction.advantages-subtitle-3' | i18next }}</h3>
          <p>{{ 'recommendation-create-introduction.advantages-content-3' | i18next }}</p>
        </li>
        <li class="introduction__advantages__list__element">
          <img
            src="https://media.sharry.land/app/images/img-tradizioni@3x.svg"
            alt="tradizioni" />
          <h3>{{ 'recommendation-create-introduction.advantages-subtitle-2' | i18next }}</h3>
          <p>{{ 'recommendation-create-introduction.advantages-content-2' | i18next }}</p>
        </li>
      </ul>
    </div>
    <div class="introduction__howto">
      <h2>{{ 'recommendation-create-introduction.howto-title' | i18next }}</h2>
      <div class="introduction__howto__stepper">
        <div class="introduction__howto__stepper__step">
          <div class="introduction__howto__stepper__step__number">
            <h4>
              <img
                src="https://media.sharry.land/app/images/ic-punto1-scegli-meraviglia.svg"
                alt="scegli meraviglia" />
            </h4>
          </div>
          <h4>{{ 'recommendation-create-introduction.howto-subtitle-1' | i18next }}</h4>
          <p>{{ 'recommendation-create-introduction.howto-content-1' | i18next }}</p>
        </div>
        <div class="introduction__howto__stepper__step">
          <div class="introduction__howto__stepper__step__number">
            <h4>
              <img
                src="https://media.sharry.land/app/images/ic-punto2-carica-foto.svg"
                alt="carica foto" />
            </h4>
          </div>
          <h4>{{ 'recommendation-create-introduction.howto-subtitle-2' | i18next }}</h4>
          <p>{{ 'recommendation-create-introduction.howto-content-2' | i18next }}</p>
        </div>
        <div class="introduction__howto__stepper__step">
          <div class="introduction__howto__stepper__step__number">
            <h4>
              <img
                src="https://media.sharry.land/app/images/ic-punto3-racconta.svg"
                alt="racconta" />
            </h4>
          </div>
          <h4>{{ 'recommendation-create-introduction.howto-subtitle-3' | i18next }}</h4>
          <p>{{ 'recommendation-create-introduction.howto-content-3' | i18next }}</p>
        </div>
        <div class="introduction__howto__stepper__step">
          <div class="introduction__howto__stepper__step__number">
            <h4>
              <img
                src="https://media.sharry.land/app/images/ic-punto4-e-poi.svg"
                alt="e poi" />
            </h4>
          </div>
          <h4>{{ 'recommendation-create-introduction.howto-subtitle-4' | i18next }}</h4>
          <p>{{ 'recommendation-create-introduction.howto-content-4' | i18next }}</p>
        </div>
      </div>
    </div>
    <div class="introduction__answers">
      <div class="introduction__answers__faqs-container">
        <div class="introduction__answers__faqs-container__title">
          <h2>{{ 'become-pro.faq.title' | i18next }}</h2>
          <p>
            {{ 'become-pro.faq.desc' | i18next }}&nbsp;<a
              [routerLink]="'faq' | routeTranslate"
              [queryParams]="{ area: '1' }"
              >{{ 'become-pro.faq.link' | i18next }}
              <sharry-icon
                registryName="caret-right"
                svgClass="svg-icon caret"></sharry-icon>
            </a>
          </p>
        </div>
        <div class="introduction__answers__faqs-container__faqs">
          <mat-accordion
            displayMode="flat"
            [multi]="true">
            @for (panel of accordionPanels; track panel.id; let last = $last) {
              <mat-expansion-panel
                class="sharry-flat-panel"
                [id]="panel.id">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ panel.title | i18next }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p [innerHTML]="panel.desc | i18next"></p>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
